// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonLoader__wrapper__ed862ee636013874c129","animated":"SkeletonLoader__animated__fe2e627c67c25fad6f5e","progress":"SkeletonLoader__progress__dd5364c436b855cd7f4c"};